import { useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { DrawLine, Sapling1, Sapling2, Chargeing } from '@/components/UI/svg/delta2max';
import NextImage from '@/components/NextImage';
import EFFreeTag from '@/components/UI/svg/delta2max/EFFreeTag';
import { buyNowMap } from '@/constants/delta2max';

export default function B() {
    const { useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('delta2max.detail');
    const { locale } = useRouter();

    useEffect(() => {
        AniContainer.create({
            asyncFromTo: [
                ['.d2x-detail-B .card-4', { opacity: 0, scale: 2.5 }, { opacity: 1, scale: 1 }, 0.6],
                ['.d2x-detail-B .card-1', { opacity: 0 }, { opacity: 1 }, 0.1],
                ['.d2x-detail-B .card-2', { opacity: 0 }, { opacity: 1 }, 0.1],
                ['.d2x-detail-B .card-3', { opacity: 0 }, { opacity: 1 }, 0.1],
                ['.d2x-detail-B .card-5', { opacity: 0 }, { opacity: 1 }, 0.1],
                ['.d2x-detail-B .card-6', { opacity: 0 }, { opacity: 1 }, 0.1],
                ['.d2x-detail-B .card-10', { opacity: 0 }, { opacity: 1 }, 0.1],
                ['.d2x-detail-B .card-9', { opacity: 0 }, { opacity: 1 }, 0.05],
                ['.d2x-detail-B .card-8', { opacity: 0 }, { opacity: 1 }, 0.05],
                ['.d2x-detail-B .card-7', { opacity: 0 }, { opacity: 1 }, 0.05],
            ],
            asyncTimeLine: [0, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1, 1.1, 1.2],
            triggerElement: '.d2x-detail-B .sec2-2',
            triggerHook: 0,
            offset: '-90%',
            duration: '80%',
        });
    }, []);
    return (
        <div
            className={`d2x-detail-B ${css.d2xDetailB} GtmModuleData-section`}
            id="d2x-detail-B"
            data-section-id={'d2x-detail-B'}
            data-section-title={t('sec2_title4')}
        >
            <div className="sec2">
                {/* @陈奕方 0608 要求us下线, 仅保留ca */}
                {/* @陈奕方 0609 要求us改回展示0520版本的 110w */}
                <div className="sec2-1">
                    <div className="left-imgs">
                        <div className="delta2max">
                            <div className="img">
                                <NextImage
                                    webpSrc={require('@publicLocal/delta2max/detail/pc/sec2_delta2max.webp')}
                                    src={require('@publicLocal/delta2max/detail/pc/sec2_delta2max.png')}
                                    alt={t('sec2_delta2max')}
                                    aria-label={t('sec2_delta2max')}
                                />
                            </div>
                            <p className="text">{t('sec2_delta2max')}</p>
                        </div>
                        <div className="solar">
                            <div className="img">
                                <NextImage
                                    webpSrc={require(`@publicLocal/delta2max/detail/pc/sec2_solar${locale === 'ca' ? '_back' : ''}.webp`)}
                                    src={require(`@publicLocal/delta2max/detail/pc/sec2_solar${locale === 'ca' ? '_back' : ''}.png`)}
                                    alt={t('sec2_solar')}
                                    aria-label={t('sec2_solar')}
                                />
                                <div className="img-icon">
                                    <EFFreeTag />
                                </div>
                            </div>
                            <p className="text">{t('sec2_solar')}</p>
                            {locale === 'ca' && <p className="text-desc">{t('sec2_solar_desc')}</p>}
                        </div>
                    </div>
                    <div className="right-info">
                        <div className="info-title">
                            {t('sec2_info_title')}
                            <div className="info-price">
                                {t.rich('sec2_info_price', {
                                    price: (text: string) => <span className="big">{text}</span>,
                                })}
                            </div>
                        </div>
                        <p className="info-desc">{t('sec2_info_desc')}</p>
                        <Link
                            className="info-buy"
                            href={buyNowMap[locale] || buyNowMap.us}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'bundle_checkout',
                                type: 'none',
                                button_name: t('sec2_info_buy'),
                            }}
                        >
                            <span>{t('sec2_info_buy')}</span>&nbsp;<span className="icon">&gt;</span>
                        </Link>
                        {locale === 'ca' && <p className="info-text">{t('sec2_info_text')}</p>}
                    </div>
                </div>
                <div className="sec2-2">
                    <div className="card card-1">
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/detail/pc/sec2_1.webp')}
                            src={require('@publicLocal/delta2max/detail/pc/sec2_1.png')}
                            alt={t('sec2_title1')}
                            aria-label={t('sec2_title1')}
                        />
                        <div className="title">{t('sec2_title1')}</div>
                        <div className="desc">{t('sec2_desc1')}</div>
                    </div>
                    <div className="card card-2">
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/detail/pc/sec2_2.webp')}
                            src={require('@publicLocal/delta2max/detail/pc/sec2_2.png')}
                            alt={t('sec2_title2')}
                            aria-label={t('sec2_title2')}
                        />
                        <div className="title">
                            {t.rich('sec2_title2_pc', {
                                big: (text: string) => <span className="big">{text}</span>,
                            })}
                        </div>
                        <div className="desc">{t('sec2_desc2')}</div>
                    </div>
                    <div className="card card-3">
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/detail/pc/sec2_3.webp')}
                            src={require('@publicLocal/delta2max/detail/pc/sec2_3.png')}
                            alt={t('sec2_title3')}
                            aria-label={t('sec2_title3')}
                        />
                        <div className="desc">
                            {t.rich('sec2_desc3', {
                                line1: (text: any) => <span style={{ color: '#05cb31' }}>{text}</span>,
                            })}
                        </div>
                        <div className="title">{t('sec2_title3')}</div>
                    </div>
                    <div className="card card-4">
                        <div className="title">{t('sec2_title4')}</div>
                        <div className="svg-box1">
                            <Sapling1 />
                        </div>
                        <div className="svg-box2">
                            <Sapling2 />
                        </div>
                    </div>
                    <div className="card card-5">
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/detail/pc/sec2_5.webp')}
                            src={require('@publicLocal/delta2max/detail/pc/sec2_5.png')}
                            alt={t('sec2_title5')}
                            aria-label={t('sec2_title5')}
                        />
                        <div className="title">{t('sec2_title5')}</div>
                    </div>
                    <div className="card card-6">
                        <div className="title">{t('sec2_title6')}</div>
                        <div className="desc">{t('sec2_desc6')}</div>
                        <div className="svg-box">
                            <DrawLine />
                        </div>
                    </div>
                    <div className="card card-7">
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/detail/pc/sec2_7.webp')}
                            src={require('@publicLocal/delta2max/detail/pc/sec2_7.png')}
                            alt={t('sec2_title7')}
                            aria-label={t('sec2_title7')}
                        />
                        <div className="title">{t('sec2_title7')}</div>
                    </div>
                    <div className="card card-8">
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/detail/pc/sec2_8.webp')}
                            src={require('@publicLocal/delta2max/detail/pc/sec2_8.png')}
                            alt={t('sec2_title8')}
                            aria-label={t('sec2_title8')}
                        />
                        <div className="title">{t('sec2_title8')}</div>
                        <div className="desc">{t('sec2_desc8')}</div>
                    </div>
                    <div className="card card-9">
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/detail/pc/sec2_9.webp')}
                            src={require('@publicLocal/delta2max/detail/pc/sec2_9.png')}
                            alt={t('sec2_title9')}
                            aria-label={t('sec2_title9')}
                        />
                        <div className="title">{t('sec2_title9')}</div>
                        <div className="svg-box">
                            <Chargeing />
                        </div>
                    </div>
                    <div className="card card-10">
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/detail/pc/sec2_10.webp')}
                            src={require('@publicLocal/delta2max/detail/pc/sec2_10.png')}
                            alt={t('sec2_title10')}
                            aria-label={t('sec2_title10')}
                        />
                        <div className="title">{t('sec2_title10')}</div>
                        <div className="desc">{t('sec2_desc10')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
